import http from "../../rest/http";

export const fetchPrivacyPolicyAndTermsAndConditionsData = async (key:any) => {
  try {
    const response = await http.get(`/v1/user/ekyc/get-consent-content?key=${key}`,{},true);
    return response;
  } catch (error:any) {
    console.error("Error fetching Pp&tcData:", error);
    throw error?.response?.data?.errorMessage;
  }
};

export const UpdateConsentConditionsAccepted = async (data: any) => {
  try {
    const response = await http.post(`/v1/user/ekyc/submit-consent`, data,"application/json",true);
    return response;
  } catch (error) {
    console.error("Error in updating consent:", error);
    throw error;
  }
};
